var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('uploader',{ref:'doc_uploader',staticClass:"uploader-example",attrs:{"autoStart":true,"options":_vm.renderUploadOptions()}},[_c('uploader-unsupport'),_c('uploader-drop',[_c('span',[_vm._v("Drop files here to upload or ")]),_c('uploader-btn',[_vm._v("select files")])],1),_c('uploader-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }